module.exports = __webpack_public_path__ + "static/gas_spore-c7f3159dd6d6c142e2b5633d17f25f15.jpg";